module.exports = __webpack_public_path__ + "media/images/answer-call-75dccda9a1bcbcdcbbcda4ba46c4ad65c0b1a166d8f0ffdf9e474558688e2399.svg";